module.exports = __webpack_public_path__ + "img/2-3.912a57a4.svg";